import { bootstrapApplication } from '@angular/platform-browser';
import { provideRouter } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideAuth0 } from '@auth0/auth0-angular';
import { AppComponent } from './app/app.component';
import { routes } from './app/app.routes';
import {
  AUTH_CONFIG,
  AUDIT_SOURCE,
  authInterceptor,
  authErrorInterceptor,
  auditSourceInterceptor,
  providePortalPermissionsBootstrapRefresh,
  provideFeatureFlags,
  providePortalTitle
} from '@lr/core';
import { environment } from './environments/environment';
import { API_BASE_URL } from '@lr/data-access';

bootstrapApplication(AppComponent, {
  providers: [
    provideRouter(routes),
    providePortalTitle('Attorney Portal'),
    provideHttpClient(
      withInterceptors([auditSourceInterceptor, authInterceptor, authErrorInterceptor])
    ),
    provideAnimations(),
    { provide: API_BASE_URL, useValue: environment.apiUrl },
    { provide: AUTH_CONFIG, useValue: environment.auth },
    { provide: AUDIT_SOURCE, useValue: 'Attorney Portal' },
    providePortalPermissionsBootstrapRefresh(),
    provideFeatureFlags(environment.auth.portalKey),
    provideAuth0({
      domain: environment.auth.domain,
      clientId: environment.auth.clientId,
      authorizationParams: {
        redirect_uri: environment.auth.redirectUri,
        audience: environment.auth.audience,
        scope: 'openid profile email offline_access',
        ...(environment.auth.connection && { connection: environment.auth.connection })
      },
      cacheLocation: environment.auth.cacheLocation,
      useRefreshTokens: environment.auth.useRefreshTokens,
      useRefreshTokensFallback: true,
      skipRedirectCallback: true,
      httpInterceptor: {
        allowedList: [
          '/api/*'
        ]
      }
    })
  ]
}).catch(err => console.error(err));


